import React, { useState, useEffect } from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Core from '@hcm4all/frontend-core'
import cn from 'classnames'

const { ChevronDown, XClose20 } = Core.UI.SVG.Icons
const { InfoCircle } = Core.UI.SVG.Icons16
const { useDebounce } = Core.hooks

const DECEMBER_INDEX = 11

export default function MainStats (props) {
  const { stats, fullView = true } = props
  const [showExpanded, setShowExpanded] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)

    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const isExpanded = isMobile || showExpanded
  const debouncedShowExpanded = useDebounce(isExpanded, 100)
  const isDecember = new Date().getMonth() === DECEMBER_INDEX
  const currentYear = new Date().getFullYear()
  const showLastYearStats = stats.year === currentYear || isDecember
  const shouldShowDetails = isMobile || debouncedShowExpanded

  return (
    <div className='calendar-main-stats'>
      <div className='available-details-container'>
        <Row
          value={stats.available}
          valueMax={stats.available_max}
          name='available'
          onIconClick={() => setShowExpanded(prev => !prev)}
          Icon={showExpanded ? XClose20 : ChevronDown}
          isMobile={isMobile}
        />
        {shouldShowDetails &&
          <>
            <Row
              value={stats.available_by_contract}
              valueMax={stats.available_by_contract_max}
              name='available_by_contract'
              hasHint
              Icon={InfoCircle}
            />
            {showLastYearStats &&
              <Row
                value={stats.from_last_year_remaining}
                valueMax={stats.from_last_year}
                name='from_last_year'
                hasHint
                Icon={InfoCircle}
                expired={stats.expired}
              />}
          </>}
        <div className='horizontal-line' />
        {fullView && isDecember &&
          <Row
            value={stats.from_next_year_remaining}
            valueMax={stats.from_next_year}
            name='from_next_year'
            hasHint
            Icon={InfoCircle}
          />}
      </div>
    </div>
  )
}

function Row (props) {
  const { value, valueMax, name, onIconClick = () => { }, Icon, hasHint = false, expired = null, isMobile = false } = props
  const displayedValue = valueMax >= 0 ? `${value}/${valueMax}` : valueMax
  const showIcon = !isMobile || hasHint

  return (
    <div className={name}>
      <div className={`indicator-icon ${name === 'available' && name}`} />
      <span>{I18n.t(`calendar.stats.${name}`)}: </span>
      {expired && expired > 0
        ? <Expired expired={expired} max={valueMax} />
        : <span>{displayedValue}</span>}
      {showIcon && (
        <IconWrapper hasHint={hasHint} name={name}>
          <Icon
            onClick={onIconClick}
            className={cn({ 'is-clickable': name === 'available' && !isMobile })}
          />
        </IconWrapper>
      )}
    </div>
  )
}

function Expired (props) {
  const { expired, max } = props

  return (
    <div className='expired-container'>
      <span className='expired-days'>{expired}</span>/<span>{max}</span>
    </div>
  )
}

function IconWrapper (props) {
  const { children, hasHint = false, name } = props
  if (!hasHint) {
    return (
      <>
        {children}
      </>
    )
  }

  return (
    <OverlayTrigger
      key='top'
      placement='top'
      overlay={
        <Tooltip id='tooltip-top'>
          {I18n.t(`calendar.stats.${name}_hint`)}
        </Tooltip>
      }
    >
      <div>
        {children}
      </div>
    </OverlayTrigger>
  )
}
